import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";
import { encryptPayload } from "./encrypt";


export const revokeAgreement = async (data) => {
    const req = `${BASE_URL}/esign/revokeWorkflowDocument`;
    const params = {
      body: data
    }
    const encryptedBodyRes = await encryptPayload("",params,true,true);
    const options = {
        method: "post",
        headers : { 
          'Content-Type': 'application/json',
         },

         body: JSON.stringify(encryptedBodyRes)
      };

      try {
        const result = await encryptPayload(req, options, false, true,true);
        return result
        
      } catch (error) {
        throw error
      }
}
export const regenerateTemplate = async (data) => {
  const req = `${BASE_URL}/template/revokeTemplateGeneration`;
  const params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true);
  const options = {
      method: "post",
      headers : { 
        'Content-Type': 'application/json',
       },

       body: JSON.stringify(encryptedBodyRes)
    };

    try {
      const result = await encryptPayload(req, options, false, true,true);
      return result
      
    } catch (error) {
      throw error
    }
}
export const recallTemplate = async (data) => {
  const req = `${BASE_URL}/template/recallTemplate`;
  const params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true);
  const options = {
      method: "post",
      headers : { 
        'Content-Type': 'application/json',
       },

       body: JSON.stringify(encryptedBodyRes)
    };

    try {
      const result = await encryptPayload(req, options, false, true,true);
      return result
      
    } catch (error) {
      throw error
    }
}

export const reInitiateEsignProcess = async (data) => {
  const req = `${BASE_URL}/esign/reinitiateEsignProcess`;
  const params = {
    body: data,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const options = {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },

    body: JSON.stringify(encryptedBodyRes),
  };

  try {
    const result = await encryptPayload(req, options, false, true, true);
    return result.data;
  } catch (error) {
    throw error;
  }
};